/**
 * @module geo/service
 */
import {
  ServiceGetImageMapParameters,
  SERVICE_GET_IMAGE_MAP
} from "../payload/facade/services/SERVICE_GET_IMAGE_MAP";
import { Service } from "./index";
import { serviceGetImageMapAsyncCreatorP } from "../actions/creators/service.get.image.map.creator";
import { fromPromise } from "rxjs/observable/fromPromise";

export class GetImageMapService extends Service {
  public getDefaultImageMap(
    parameters?: Partial<ServiceGetImageMapParameters>,
    transientService?: boolean,
    idService?: string
  ) {
    const { id, transient } = this.getIdAndTransient({
      transient: transientService,
      id: idService
    });
    const soptions = new SERVICE_GET_IMAGE_MAP({
      parameters,
      id,
      transient
    });
    return fromPromise(
      serviceGetImageMapAsyncCreatorP(soptions, this.store.dispatch)
    );
  }
}
